import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgxPermissionsModule } from 'ngx-permissions';
import { PermissionGuard } from '../../core/guards/permissions.guard';

const routes: Routes = [
  {
    path: 'location-types',
    loadChildren: () =>
      import('./features/location-types/location-types.module').then((m) => m.LocationTypesModule),
    canActivate: [PermissionGuard],
    data: { breadcrumb: 'Location Types', permissions: ['LocationType:View'], requireAll: false },
  },

  {
    path: 'location-formats',
    loadChildren: () =>
      import('./features/location-formats/location-formats.module').then(
        (m) => m.LocationFormatsModule,
      ),
    canActivate: [PermissionGuard],
    data: {
      breadcrumb: 'Location Formats',
      permissions: ['LocationFormat:View'],
      requireAll: false,
    },
  },

  {
    path: 'storage-units',
    loadChildren: () =>
      import('./features/storage-units/storage-units.module').then((m) => m.StorageUnitsModule),
    canActivate: [PermissionGuard],
    data: { breadcrumb: 'Storage Units', permissions: ['StorageUnit:View'], requireAll: false },
  },

  {
    path: 'shipment-boxes',
    loadChildren: () =>
      import('./features/shipment-boxes/shipment-boxes.module').then((m) => m.ShipmentBoxesModule),
    data: { breadcrumb: 'Package Types' },
  },

  {
    path: 'location-profiles',
    loadChildren: () =>
      import('./features/location-profiles/location-profiles.module').then(
        (m) => m.LocationProfilesModule,
      ),
    canActivate: [PermissionGuard],
    data: {
      breadcrumb: 'Location Profiles',
      permissions: ['LocationProfile:View'],
      requireAll: false,
    },
  },
  
  {
    path: 'warehouses',
    loadChildren: () =>
      import('./features/warehouses/warehouses.module').then((m) => m.WarehousesModule),
    canActivate: [PermissionGuard],
    data: { breadcrumb: 'Warehouses', permissions: ['Warehouse:View'], requireAll: false },
  },

  {
    path: 'zones',
    loadChildren: () => import('./features/zones/zones.module').then((m) => m.ZonesModule),
    canActivate: [PermissionGuard],
    data: { breadcrumb: 'Zones', permissions: ['Zone:View'], requireAll: false },
  },
  
  {
    path: 'zone-types',
    loadChildren: () =>
      import('./features/zone-types/zone-types.module').then((m) => m.ZoneTypesModule),
    canActivate: [PermissionGuard],
    data: { breadcrumb: 'Zone Types', permissions: ['ZoneType:View'], requireAll: false },
  },
  
  {
    path: 'locations',
    loadChildren: () =>
      import('./features/locations/locations.module').then((m) => m.LocationsModule),
    canActivate: [PermissionGuard],
    data: { breadcrumb: 'Locations', permissions: ['Location:View'], requireAll: false },
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    RouterModule.forChild(routes),
    NgxPermissionsModule.forChild(),
  ],
})
export class WarehouseManagementModule {}
